import { render } from "./MaoInfo.vue?vue&type=template&id=68e284d1&scoped=true"
import script from "./MaoInfo.vue?vue&type=script&lang=js"
export * from "./MaoInfo.vue?vue&type=script&lang=js"

import "./MaoInfo.vue?vue&type=style&index=0&id=68e284d1&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68e284d1"]])

export default __exports__